import React, {useEffect, useState} from "react";
import {Flex, Icon, IconButton, Slider, SliderFilledTrack, SliderThumb, SliderTrack} from "@chakra-ui/react";
import {AiOutlineFontSize, AiOutlineMinus, AiOutlinePlus} from "react-icons/ai";

export interface FontSizeSliderProps {
  defaultValue: number;
  onChange: (val: number) => void;
}

const FontSizeSlider = ({defaultValue, onChange}: FontSizeSliderProps) => {
  const [fontSize, setFontSize] = useState(defaultValue);

  useEffect(() => {
    onChange(fontSize)
  }, [fontSize])

  return (
    <Flex pos={'fixed'} right={8} bottom={8} w={48} align={'center'} zIndex={1} _hover={{bgColor: '#101E23CF'}} p={2} rounded={8}>
      <Icon as={AiOutlineFontSize} mr={4} title={'adjust font size'}/>
      <IconButton variant={'ghost'} icon={<AiOutlineMinus/>} aria-label={'smaller'} onClick={() => setFontSize(prevState => Math.max(prevState - 1, 0))}/>
      <Slider aria-label="font-size" value={fontSize}  min={0} max={12} step={1} onChange={val => setFontSize(val)}>
        <SliderTrack>
          <SliderFilledTrack />
        </SliderTrack>
        <SliderThumb />
      </Slider>
      <IconButton variant={'ghost'} icon={<AiOutlinePlus/>} aria-label={'smaller'} onClick={() => setFontSize(prevState => Math.min(prevState + 1, 12))}/>
    </Flex>
  )
}

export default FontSizeSlider
